import instance from "./index.js"

export function getAction(url, params, options = {}) {
  return new Promise((resolve, reject) => {
    /*
    * 在请求api中添加自定义配置对象,导入下面的config对象,在instance.get中传入config对象
     * getAction("/info", params,{ showLoading: false })
     * 这样就不会显示loading加载动效组件
     */


    const config = {
      custom: {
        ...instance.defaults.custom,
        ...options
      }
    }
    if (url.includes('info')) {
      console.log('getconfig:', config);
    }
    instance.get(url, { ...params, ...config })
      .then((res) => {
        // console.log('get res:',res);
        resolve(res.data)
      })
      .catch((err) => {
        // console.log('get err:',err);
        reject(err.data)
      })
  })
}

export function postAction(url, params, options = {}) {
  return new Promise((resolve, reject) => {

    /**
     * 当某些url不需要显示loading加载动效组件时
     * 有两种方式
     * 1:在请求拦截器添加判断
     * // 请求拦截器
        instance.interceptors.request.use(config => {
          if (config.url === '/test') {
            config.custom.showLoading = false;
          } else {
            config.custom.showLoading = true;
          }
          return config;
        }, error => {
          return Promise.reject(error);
        });
     *
     * 2:在请求api中添加自定义配置对象,导入下面的config对象,在instance.post中传入config对象
     * 例如: postAction('/test', params, { showLoading: false })
     * 这样就不会显示loading加载动效组件
     */
    const config = {
      custom: {
        ...instance.defaults.custom,
        ...options
      }
    }
    instance.post(url, params, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.data)
      })
  })
}
export function postAction2(url, params, config) {
  return new Promise((resolve, reject) => {
    instance.post(url, params, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.data)
      })
  })
}

export function menuGetAction(url, data) {
  let str = ''
  let value = ''
  Object.keys(data).forEach(item => {
    str += item
    value += data[item]
    url = `${url}?${str}=${value}`
  })

  return new Promise((resolve, reject) => {
    instance.get(url)
      .then(res => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.data)
      })
  })
}